import axios from "axios";
import { useQueryString } from "@/utils/query-string";


const axiosYt = axios.create({
  baseURL: `${vueOptions.VUE_APP_BASE_URL_BACKEND || ""}`,
  timeout: 10000,
  paramsSerializer: (params) => {
    const { stringifyQuery } = useQueryString();

    return stringifyQuery(params);
  },
});

export { axiosYt };
